/* ===========================
IMPORTS
=========================== */
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// IMPORT - STYLING
import '../../assets/css/Rules.css';
// IMPORT - COMPONENTS
// IMPORT - ELEMENTS
import Tables from '../Elements/Tables';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class RulesPreview extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   */
  constructor(props) {
    super(props);

    this.state = {
      timestamp: ((new Date()).getTime()),
      priority: this.props.priority,
      errors: null,
      data: [],
      meta: {},
      page: 1,
      limit: 50,
      sortBy: 'id',
      direction: 'asc',
      columns: {},
      loading: false,

      optionsColumns: [
        'id',
        'device_id',
        'stack_host',
        'timezone',
        'bundle_rule_name',
        'bundle',
        'created_at',
        'updated_at',
      ],

      optionsColumnsDefault: [
        'id',
        'device_id',
        'name',
        'bundle_rule_name',
        'bundle',
      ],

      optionsColumnLabels: {
        device_id: 'Device ID',
        name: 'Name',
        bundle_rule_name: 'Bundle Rule',
        bundle: 'Bundle',
      },

      optionsColumnsSortable: [
        'id',
        'device_id',
        'stack_host',
        'timezone',
        'is_active',
        'called_at',
        'created_at',
        'updated_at',
      ],
    };

    // bind function
    this.post = this.post.bind(this);
    this.updateColumns = this.updateColumns.bind(this);
    this.updateColumnsShowHide = this.updateColumnsShowHide.bind(this);
    this.updatePage = this.updatePage.bind(this);
    this.updateSortDirection = this.updateSortDirection.bind(this);
  }

  /**
   */
  componentDidMount() {
    // Load default settings
    try {
      if (localStorage.defaultColumnsRulesPreview === undefined
        || JSON.parse(localStorage.defaultColumnsRulesPreview).length === 0) {
        localStorage.defaultColumnsRulesPreview = JSON.stringify(this.state.optionsColumnsDefault);
      }
      this.setState({
        optionsColumnsDefault: JSON.parse((localStorage.defaultColumnsRulesPreview || [])),
      });
    } catch (e) {
      this.setState({
        errors: {
          message: 'Could load saved preferences.',
        },
      });
    }
  }

  /**
   * @param {object} nextProps
   */
  componentDidUpdate() {
    if (this.props.priority !== null
      && this.props.priority !== undefined
      && this.props.timestamp !== this.state.timestamp) {
      this.setState({
        timestamp: this.props.timestamp,
        priority: this.props.priority,
        optionsColumnsDefault: JSON.parse((localStorage.defaultColumnsRulesPreview || [])),
      }, () => {
        clearTimeout(this.mainTimeout);
        this.mainTimeout = setTimeout(() => {
          this.post();
        }, 300);
      });
    } else if ((this.props.priority === undefined || this.props.priority === null)
      && this.props.timestamp !== this.state.timestamp) {
      this.setState({
        timestamp: this.props.timestamp,
        priority: null,
        data: [],
        meta: {},
        page: 1,
        limit: 50,
        columns: {},
      });
    }
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   */
  mainTimeout = null;

  /**
   * @param {object} params
   * @param {object} payload
   * @param {function} callback
   * @param {functio } failback
   */
  post(params, payload, callback, failback) {
    this.setState({
      errors: null,
      loading: true,
    }, () => {
      // Make initial request
      const defaultParams = {
        priority: this.state.priority,
        page: this.state.page,
        limit: this.state.limit,
        order_by: `${this.state.sortBy}.${this.state.direction}`,
      };

      const defaultPayload = {
        bundle_rules: this.props.data.map((res) => {
          const item = res;
          item.bundle_id = null;
          if (item.bundle && item.bundle.id) {
            item.bundle_id = item.bundle.id;
          }

          return item;
        }),
      };

      RulesPreview.requestPost(
        (params || defaultParams),
        // payload
        (payload || defaultPayload),
        // callback
        (response) => {
          if (callback) {
            callback(response);
          } else if (response.players && response.meta) {
            const columns = {};

            (this.state.optionsColumns).map((item) => {
              if (typeof (item) === 'object' && item.name) {
                columns[item.name] = {
                  label: (this.state.optionsColumnLabels[item.name])
                    ? this.state.optionsColumnLabels[item.name]
                    : null,
                  search: (this.state.columns[item.name])
                    ? this.state.columns[item.name].search
                    : '',
                  parent: false,
                  sortable: (this.state.optionsColumnsSortable.indexOf(item.name) > -1),
                };

                if (this.state.columns[item.name] && this.state.columns[item.name].visible) {
                  columns[item.name].visible = this.state.columns[item.name].visible;
                } else if (this.state.optionsColumnsDefault
                  && this.state.optionsColumnsDefault.indexOf(item.name) === -1) {
                  columns[item.name].visible = false;
                } else {
                  columns[item.name].visible = true;
                }

                if (item.columns && item.columns.length > 0) {
                  item.columns.map((child) => {
                    columns[`${item.name}.${child}`] = {
                      label: (this.state.optionsColumnLabels[`${item.name}.${child}`])
                        ? this.state.optionsColumnLabels[`${item.name}.${child}`]
                        : null,
                      search: (this.state.columns[`${item.name}.${child}`])
                        ? this.state.columns[`${item.name}.${child}`].search
                        : '',
                      parent: item.name,
                      sortable: (this.state.optionsColumnsSortable.indexOf(`${item.name}.${child}`) > -1),
                    };

                    if (this.state.columns[`${item.name}.${child}`] && this.state.columns[`${item.name}.${child}`].visible) {
                      columns[`${item.name}.${child}`].visible = this.state.columns[`${item.name}.${child}`].visible;
                    } else if (this.state.optionsColumnsDefault
                      && this.state.optionsColumnsDefault.indexOf(`${item.name}.${child}`) === -1) {
                      columns[`${item.name}.${child}`].visible = false;
                    } else {
                      columns[`${item.name}.${child}`].visible = true;
                    }

                    return child;
                  });
                }
              } else {
                columns[item] = {
                  label: (this.state.optionsColumnLabels[item])
                    ? this.state.optionsColumnLabels[item]
                    : null,
                  search: (this.state.columns[item])
                    ? this.state.columns[item].search
                    : '',
                  parent: false,
                  sortable: (this.state.optionsColumnsSortable.indexOf(item) > -1),
                };

                if (this.state.columns[item] && this.state.columns[item].visible) {
                  columns[item].visible = this.state.columns[item].visible;
                } else if (this.state.optionsColumnsDefault
                  && this.state.optionsColumnsDefault.indexOf(item) === -1) {
                  columns[item].visible = false;
                } else {
                  columns[item].visible = true;
                }
              }
              return item;
            });

            this.setState({
              data: response.players,
              meta: response.meta,
              columns,
              loading: false,
            });
          } else {
            this.setState({
              loading: false,
            });
          }
        },
        // failback
        (error) => {
          if (failback) {
            failback(error);
          } else {
            this.setState({
              errors: error,
              loading: false,
            });
          }
        },
      );
    });
  }

  /**
   * @param {object} params
   * @param {object} payload
   * @param {function} callback
   * @param {function} failback
   */
  static requestPost(params, payload, callback, failback) {
    let query = '';
    if (params && Object.keys(params).length > 0) {
      Object.keys(params).map((key) => {
        query += `${key}=${params[key]}&`;
        return key;
      });
      query = `?${query}`;
    }

    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/bundle_rules/players${query}`,
      'post',
      JSON.stringify(payload),
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
   * @param {integer} page
   */
  updatePage(page) {
    this.setState({
      page,
    }, () => {
      this.post();
    });
  }

  /**
   * @param {string} key
   */
  updateSortDirection(key) {
    this.setState((prevState) => {
      let direction = (prevState.direction === 'asc') ? 'desc' : 'asc';
      direction = (prevState.sortBy !== key) ? 'asc' : direction;

      return {
        sortBy: key,
        direction,
      };
    }, () => {
      this.post();
    });
  }

  /**
   * @param {object} columns
   * @param {string} key
   */
  updateColumnsShowHide(columns, key, show) {
    // Set defaults for localStorage
    if (localStorage.defaultColumnsRulesPreview
      && localStorage.defaultColumnsRulesPreview.length > 0) {
      let def = JSON.parse(localStorage.defaultColumnsRulesPreview);
      if (show) {
        def.push(key);
      } else {
        def = [...def.slice(0, def.indexOf(key)), ...def.slice((def.indexOf(key) + 1))];
      }
      localStorage.defaultColumnsRulesPreview = JSON.stringify(def);
    } else {
      localStorage.defaultColumnsRulesPreview = JSON.stringify([key]);
    }

    // if reseting the search make an updated request
    if (columns[key].search.length > 0 && !show) {
      const resetColumns = { ...columns };
      resetColumns[key].search = '';
      this.setState({
        columns: resetColumns,
        optionsColumnsDefault: JSON.parse(localStorage.defaultColumnsRulesPreview),
      }, () => {
        this.post();
      });
    } else { // if no search was present just hide/show the field
      this.setState({
        columns,
        optionsColumnsDefault: JSON.parse(localStorage.defaultColumnsRulesPreview),
      });
    }
  }

  /**
   * @param {object} columns
   */
  updateColumns(columns) {
    this.setState({
      columns,
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.post();
      }, 350);
    });
  }

  /**
   */
  getTitle() {
    if (this.state.priority !== undefined && this.state.priority !== null) {
      if (this.props.data[this.state.priority]
        && this.props.data[this.state.priority].name.length > 0) {
        return this.props.data[this.state.priority].name;
      }
      return (this.state.priority + 1);
    }
    return '';
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div>
        <div className="page-header">
          <h1>
            {'Preview '}
            <code>{this.getTitle()}</code>
          </h1>
        </div>

        {(this.state.errors)
          ? (
            <div className="errors">
              <div className="alert alert-danger">{(this.state.errors.message) ? this.state.errors.message : 'Something went wrong.'}</div>
            </div>
          )
          : ''}

        <div className="content">
          <Tables
            uniqueKey="id"
            search={this.state.search}
            data={this.state.data}
            meta={this.state.meta}
            page={this.state.page}
            limit={this.state.limit}
            columns={this.state.columns}
            sortBy={this.state.sortBy}
            direction={this.state.direction}
            loading={this.state.loading}
            optionsLimits={this.state.optionsLimits}
            optionsSelections={{}}
            optionsShowSearch={false}
            optionsShowSelection={false}
            optionsShowLimit={false}
            optionsShowSearchColumn={false}
            onUpdateSearch={this.updateSearch}
            onUpdatedColumns={this.updateColumns}
            onUpdateColumnsShowHide={this.updateColumnsShowHide}
            onUpdatedLimits={this.updateLimits}
            onUpdatePage={this.updatePage}
            onUpdateSortDirection={this.updateSortDirection}
          />
        </div>
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
RulesPreview.propTypes = {
  data: PropTypes.array,
  timestamp: PropTypes.number,
  priority: PropTypes.number,
};

/* ===========================
EXPORT
=========================== */
export default withRouter(RulesPreview);
